module.exports = __webpack_public_path__ + "img/firmaamonestaciones.8bb1a945.png";